import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Upload, FileSpreadsheet } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OrdersActiveUpload = ({ user, onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false);

  const handleDownloadTemplate = async () => {
    try {
      const response = await axios.get(`${API}/template/download/orders`, {
        headers: { 'Authorization': `Bearer ${user.token}` },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Active_Orders_Upload_Template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Template downloaded successfully');
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download template');
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(`${API}/orders/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      toast.success(response.data.message);
      
      if (response.data.errors && response.data.errors.length > 0) {
        toast.warning(`Some rows had errors. Check console for details.`);
        console.log('Upload errors:', response.data.errors);
      }
      
      e.target.value = ''; // Reset file input
      if (onUploadSuccess) onUploadSuccess();
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(error.response?.data?.detail || 'Failed to upload orders');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={handleDownloadTemplate}
        variant="outline"
        size="sm"
      >
        <FileSpreadsheet className="w-4 h-4 mr-2" />
        Download Template
      </Button>
      
      <label>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={handleFileUpload}
          className="hidden"
          disabled={uploading}
        />
        <Button
          as="span"
          variant="outline"
          size="sm"
          disabled={uploading}
          onClick={() => document.querySelector('input[type="file"]').click()}
        >
          <Upload className="w-4 h-4 mr-2" />
          {uploading ? 'Uploading...' : 'Upload Excel'}
        </Button>
      </label>
    </div>
  );
};

export default OrdersActiveUpload;
